const HASURA_CLAIMS_NAMESPACE = 'https://hasura.io/jwt/claims';

const ACCESS_ERROR_CODES = [
    'invalid-jwt',
    'jwt-invalid-claims',
    'jwt-missing-role-claims',
    'invalid-headers',
    'access-denied',
];

/**
 * True when the Firebase token claims carry a non-empty Hasura allowed-roles list. Customer and
 * temp-driver custom-token sessions pass; pending, deactivated and brand-new accounts do not.
 * @param {object} [claims] Claims from `user.getIdTokenResult()`.
 * @returns {boolean}
 */
export const hasHasuraAccess = (claims) => {
    const roles = claims?.[HASURA_CLAIMS_NAMESPACE]?.['x-hasura-allowed-roles'];
    return Array.isArray(roles) && roles.length > 0;
};

/**
 * True when an Apollo error means Hasura rejected the session's JWT claims (lost or missing access),
 * as opposed to an ordinary query error.
 * @param {object} [error] An Apollo `ErrorResponse`.
 * @returns {boolean}
 */
export const isAccessClaimsError = (error) => {
    const networkErrors = error?.networkError?.result?.errors;
    const errors = [
        ...(Array.isArray(error?.graphQLErrors) ? error.graphQLErrors : []),
        ...(Array.isArray(networkErrors) ? networkErrors : []),
    ];
    return errors.some((e) => ACCESS_ERROR_CODES.includes(e?.extensions?.code));
};
